import * as disabilitiesList from './disabilitiesList';

import {combineReducers} from "redux";
import {all, fork} from "redux-saga/effects";

export interface IState  {
    disabilitiesList: disabilitiesList.IState
}

export const ActionCreators = {
    disabilitiesList: disabilitiesList.ActionCreators,
}

export const Reducers = combineReducers<IState>({
    disabilitiesList: disabilitiesList.Reducers,
});

export function* sagas() {
    yield all([
        fork(disabilitiesList.sagas),
    ]);
}

